import React, { FC } from 'react';
import { StatsCardProps } from './StatsCardProps';
import Card, { ContentCard } from '@ingka/card';
import { getIdFromLabel } from '../../utils/utils';
import Text from '@ingka/text';
import Skeleton from '@ingka/skeleton';

const StatsCard: FC<StatsCardProps> = ({
  value,
  label,
  helperText,
  loading,
}) => {
  return loading ? (
    <Skeleton className={'stats-card'} height={'100px'} width={'100%'} />
  ) : (
    <Card
      content={
        <ContentCard
          id={getIdFromLabel(label)}
          className={'stats-card'}
          label={<Text textStyle={'Body.S'}>{label}</Text>}
          title={<Text textStyle={'Heading.S'}>{value}</Text>}
          body={helperText}
          size="small"
          fixed
        />
      }
    />
  );
};

export default StatsCard;
